/**
 * Normalizes a trust markers combination from the API for rendering.
 * Reorder runs here so logo order is stable before paint (avoids post-load reorder CLS).
 */
export function processTrustMarkersCombination(combination) {
  if (
    !combination ||
    !Array.isArray(combination.trustMarker) ||
    combination.trustMarker.length === 0
  ) {
    return combination || null
  }

  const trustMarker = combination.trustMarker.map((item) => {
    const baseFields = item.fields ?? item

    return {
      metadata: item.metadata ?? null,
      sys: item.sys ?? null,
      fields: {
        ...baseFields,
        color: '#33b083',
      },
    }
  })

  const [firstElement, ...rest] = trustMarker

  return {
    ...combination,
    trustMarker: [...rest, firstElement],
  }
}
